<template>
  <div class="c-cp-intro">
  	<img :src="customerthumbnail" class="c-cp-intro__avatar" />
  	<span>{{ customername }}</span><h1>{{$t("welcome.hello")}}</h1>
  </div>
</template>

<script>
	export default {
	  name: 'welcome',
	  data () {
	    return {};
	  }, 
	  props: ['customername', 'stronglylinked', 'customerthumbnail']
	};
</script>


// WEBPACK FOOTER //
// src/components/welcome.vue